export const defaultShopProductFilters = {
  query: "",
  category: "Alle",
  availability: "all",
  minPrice: "",
  maxPrice: "",
  sort: "newest",
};

export function filterShopProducts(listings, filters) {
  const query = filters.query.trim().toLocaleLowerCase("da-DK");
  const minPrice = optionalNumber(filters.minPrice);
  const maxPrice = optionalNumber(filters.maxPrice);

  return listings
    .filter((listing) => {
      const price = listingPrice(listing);
      const inventory = listingInventory(listing);
      const category = listing.shopCategory || listing.shop_category || "Ukategoriseret";
      const searchableText = [listing.title, listing.description, listing.condition, category]
        .filter(Boolean)
        .join(" ")
        .toLocaleLowerCase("da-DK");

      return (!query || searchableText.includes(query))
        && (filters.category === "Alle" || category === filters.category)
        && (filters.availability !== "available" || inventory > 0)
        && (filters.availability !== "out" || inventory <= 0)
        && (minPrice === null || price >= minPrice)
        && (maxPrice === null || price <= maxPrice);
    })
    .sort((left, right) => compareListings(left, right, filters.sort));
}

export function shopProductCategories(listings) {
  return [...new Set(listings.map((listing) => listing.shopCategory || listing.shop_category).filter(Boolean))]
    .sort((left, right) => left.localeCompare(right, "da"));
}

function compareListings(left, right, sort) {
  if (sort === "price-asc") return listingPrice(left) - listingPrice(right);
  if (sort === "price-desc") return listingPrice(right) - listingPrice(left);
  if (sort === "title") return (left.title || "").localeCompare(right.title || "", "da");
  return 0;
}

function listingPrice(listing) {
  if (Number.isFinite(listing.priceAmount)) return listing.priceAmount;
  if (Number.isFinite(listing.price_amount)) return listing.price_amount;
  const parsed = Number.parseFloat(listing.price);
  return Number.isFinite(parsed) ? parsed : 0;
}

function listingInventory(listing) {
  if (Number.isFinite(listing.inventoryCount)) return listing.inventoryCount;
  return Number.isFinite(listing.inventory_count) ? listing.inventory_count : 0;
}

function optionalNumber(value) {
  if (value === "" || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
